<div *ngIf='sessionData' class='ChangePassword'>
  <div class='ChangePassword-header d-flex flex-row'>
    <div class='flex-grow-1'>
      <h4 class='title__page'>Settings</h4>
    </div>
    <div class='flex-grow-0'>
      <app-button
        [color]="'blue'"
        [route]="'/messages'"
        [style]="'outline'"
        size='small'
        text='Back to Inbox'></app-button>
    </div>
  </div>
  <div class='ChangePassword-body'>
    <div class='row'>
      <div class='col col-12 col-sm-9 offset-sm-3'>
        <div class='ChangePassword-form'>
          <div class='row'>
            <div class='col col-12'>
              <h6 class='title__page'>Login & Security</h6>
            </div>
          </div>
          <form [formGroup]='formGroup'>
            <div class='row'>
              <div class='col col-12'>
                <div class='ChangePassword-form-label'>
                  <p class='mb-0'>Current Password</p>
                </div>
                <app-text-field
                  [allowViewPassword]='true'
                  formControlName='current_password'
                  placeholder='Enter current password'
                  type='password'></app-text-field>
              </div>
            </div>
            <div *ngIf='error && error.old' class='row mt-3'>
              <div class='col col-12'>
                <div class='alert alert-danger'>
                  <p class='mb-0'>{{ error.old }}</p>
                </div>
              </div>
            </div>
            <div class='row mt-3'>
              <div class='col col-12'>
                <div class='ChangePassword-form-label'>
                  <p class='mb-0'>New Password</p>
                </div>
                <app-text-field
                  [allowViewPassword]='true'
                  formControlName='new_password'
                  placeholder='Enter new password'
                  type='password'></app-text-field>
                <div *ngIf='hasControlErrors(newPassword)' class='alert alert-danger'>
                  <div *ngIf='newPassword.errors.required'>
                    <p class='mb-0'>Password is required.</p>
                  </div>
                  <div *ngIf='newPassword.errors.minlength'>
                    <p class='mb-0'>Password must be at least 8 characters long.</p>
                  </div>
                  <div *ngIf='newPassword.errors.pattern'>
                    <ul>
                      <li>Numbers: 0 to 9</li>
                      <li>Uppercase Letters: ABC</li>
                      <li>Lowercase Letters: abc</li>
                      <li>Special Characters: ! @ # $ % & * ( ) _ + - = &#123;} [ ] ; : ' " < > , . ? /</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class='row mt-3'>
              <div class='col col-12'>
                <div class='ChangePassword-form-label'>
                  <p class='mb-0'>Confirm Password</p>
                </div>
                <app-text-field
                  [allowViewPassword]='true'
                  formControlName='confirm_password'
                  placeholder='Confirm your new password'
                  type='password'></app-text-field>
                <div
                  *ngIf='hasControlErrors(confirm_password)'
                  class='alert alert-danger'>
                  <div *ngIf='confirm_password.errors.required'>
                    <p class='mb-0'>Please, repeat your password</p>
                  </div>
                  <div *ngIf='confirm_password.errors.minlength'>
                    <p class='mb-0'>Password must be at least 8 characters long.</p>
                  </div>
                  <div *ngIf='confirm_password.errors.passwordsDontMatch'>
                    <p class='mb-0'>Password didn't match as above</p>
                  </div>
                </div>
              </div>
            </div>
            <div class='row mt-5'>
              <div class='col col-12 d-flex'>
                <app-button
                  [color]='cancelButtonProperties.color'
                  [route]='cancelButtonProperties.route'
                  [size]='cancelButtonProperties.size'
                  [style]='cancelButtonProperties.style'
                  [text]='cancelButtonProperties.text'
                  class='ChangePassword-form-button'></app-button>
                <app-button
                  [Click]='updateButtonProperties.onClick'
                  [color]='updateButtonProperties.color'
                  [disabled]='updateButtonProperties.observeApi'
                  [size]='updateButtonProperties.size'
                  [style]='updateButtonProperties.style'
                  [text]='updateButtonProperties.text'
                  class='ChangePassword-form-button'></app-button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
